import React, { useEffect, useState } from 'react'
import { Spin, Typography, message } from 'antd'
import axios from 'axios'
import { useHistory } from 'react-router-dom'
import MainCSoftAccess, { CollAccess, CollParameters } from '../c-softaccess/MainCSoftAccess'

export interface ConquestSoftAccessInitData {
  orgaId: string
  softaccessId?: string | null
  isNew: boolean
  filesIris: Array<[string, string]>
  filesPdv: Array<[string, string]>
  myForm: Record<string, string>
  collaborators: CollParameters[]
  accesses: CollAccess[] | null
}

interface ConquestSoftAccessPageProps {
  orgaId: string
  softaccessId: string
}

export function ConquestSoftAccessPage({ orgaId, softaccessId }: ConquestSoftAccessPageProps) {
  const history = useHistory()
  const [initData, setInitData] = useState<ConquestSoftAccessInitData | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const load = async () => {
      setLoading(true)
      try {
        const { data } = await axios.get<ConquestSoftAccessInitData>(
          `/organisations/${orgaId}/conquest/softwaresaccesses/${softaccessId}/init`,
        )
        setInitData(data)
      } catch (error) {
        console.error(error)
        message.error("Impossible de charger l'accès Conquest")
      } finally {
        setLoading(false)
      }
    }
    load()
  }, [orgaId, softaccessId])

  if (loading || !initData) {
    return (
      <div style={{ padding: 48, textAlign: 'center' }}>
        <Spin size="large" />
      </div>
    )
  }

  return (
    <div style={{ marginTop: 16 }}>
      <Typography.Title level={4}>
        {initData.isNew ? 'Ajouter un accès logiciel Conquest' : 'Modification accès logiciel Conquest'}
      </Typography.Title>
      <MainCSoftAccess
        orgaId={orgaId}
        softaccessId={initData.softaccessId || ''}
        isNew={initData.isNew}
        filesIris={initData.filesIris}
        filesPdv={initData.filesPdv}
        myForm={initData.myForm}
        collaborators={initData.collaborators}
        initialAccesses={initData.accesses}
        onCancel={() => history.push(`/organisations/${orgaId}/softwares`)}
        onSaved={() => history.push(`/organisations/${orgaId}/softwares`)}
      />
    </div>
  )
}
